import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { useStaticQuery, graphql } from "gatsby"
import FeatureCarousel from "../components/FeatureCarousel/FeatureCarousel"
import { StoriesTeaserAndCTA } from "../components/StoriesTeaserAndCTA"
import { Neighbourhoods } from "components/Neighbourhoods"
import FullwidthCTA from "../components/FullwidthCTA/FullwidthCTA"
import { ThreeTeaserComponent } from "../components/Teaser"
import { FourTeaserComponent } from "../components/Teaser"
import { SubsitePageWrapper } from "components/ProjectStyles"
import { DividerLines } from "../components/DividerLines"

const SubsitePage = () => {
  const data = useStaticQuery(
    graphql`
      query {
        getFourTeaserImagesLive: allFile(
          filter: { absolutePath: { regex: "/four-teaser-images/" } }
          sort: { fields: [name], order: ASC }
        ) {
          edges {
            node {
              id
              name
              childImageSharp {
                fluid(maxWidth: 1400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        getWeatherImages: allFile(
          filter: { absolutePath: { regex: "/weather-images/" } }
          sort: { fields: [name], order: ASC }
        ) {
          edges {
            node {
              id
              name
              childImageSharp {
                fluid(maxWidth: 1400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `
  )

  return (
    <Layout
      subsite
      site="live"
      preTitle="One of the world's"
      headerTitle="most liveable cities"
      headerText="Canberra offers the ultimate work/life balance with access to world-class facilities, stunning natural surrounds and great career opportunities."
    >
      <SEO title="Subsite" />
      <SubsitePageWrapper>
        <FeatureCarousel />
        <DividerLines />

        <ThreeTeaserComponent
          mainTitle="GETTING SETTLED"
          data={[
            {
              title: "Lifestyle",
              excerpt:
                "The ultimate work/life balance with access to world-class facilities, stunning natural surrounds and great career opportunities.",
              link: "/",
              label: "Find out more",
            },
            {
              title: "Housing & Cost of Living",
              excerpt:
                "A home is the foundation for your life in Canberra. Learn more about the areas you want to live in and options to suit you and your family.",
              link: "/",
              label: "Find out more",
            },
            {
              title: "Business in Canberra",
              excerpt:
                "There’s no better place to do business. This is where key decision makers meet, negotiations take place and brilliant possibilities come to life.",
              link: "/",
              label: "Find out more",
            },
          ]}
        />
        <Neighbourhoods />
        <FullwidthCTA />
        <StoriesTeaserAndCTA />
        <DividerLines />
        <FourTeaserComponent
          weather
          mainTitle="Canberra’s Seasonal Charms"
          mainExcerpt="Canberra is a rare treat among Australian cities, providing a kaleidoscope of colour, activity and experiences based around our four distinct seasons."
          mainTag={"WEATHER & CLIMATE"}
          img={data.getWeatherImages.edges}
          data={[
            {
              title: "Spring",
              excerpt:
                "Spring in Canberra is exquisite. You’ll find flowers in bloom and the weather warming.",

              link: "/",
            },
            {
              title: "Summer",
              excerpt:
                "Grab your hat and don the short sleeves; summer is a great time to explore the outdoors.",

              link: "/",
            },
            {
              title: "Autumn",
              excerpt:
                "Autumn is a particularly beautiful time of year to watch Canberra’s seasonal transition.",

              link: "/",
            },
            {
              title: "Winter",
              excerpt:
                "The ideal time to visit galleries and museums, enjoy winter activities and indulgent dining with local wines.",

              link: "/",
            },
          ]}
        />
      </SubsitePageWrapper>
    </Layout>
  )
}

export default SubsitePage
